import { Injectable } from '@angular/core';
import { CrossStudyPortalAppConfig } from 'projects/cross-study-portal-lib/src/lib/interfaces/app-config';
import { AppConfigLoaderService } from 'projects/cross-study-portal-lib/src/public-api';

@Injectable({
  providedIn: 'root',
})
export class ContextInitializationResponseHandlerService {
  async handler(initContextResponse: Response, appConfigLoader: AppConfigLoaderService<CrossStudyPortalAppConfig>) {
    if (initContextResponse.ok) return initContextResponse;

    if (initContextResponse.status !== 401) {
      throw new Error('failed to load Context');
    }

    const body = await initContextResponse.json();

    if (body.loginUrl) {
      window.location.href = `${body.loginUrl}`;
      return initContextResponse;
    }

    return this.redirectToLogin(appConfigLoader);
  }

  redirectToLogin(appConfigLoader: AppConfigLoaderService<CrossStudyPortalAppConfig>) {
    return appConfigLoader.getConfig$().subscribe(appConfig => {
      window.location.href = `${appConfig.loginUrl}`;
    });
  }
}
